import React from "react"
import {
  Container,
  Modal,
  Button,
  Header,
  Form,
  Grid,
  Label,
  Loader,
  Dimmer,
} from "semantic-ui-react"
import InputMask from "react-input-mask"
import { connect } from "react-redux"
import {
  selectStore,
  createStore,
  getStores,
  deleteStore,
  editStore,
  closeFirstEntry,
  changeFirstEntryFunction,
  signIn,
  signOut,
} from "../ducks/profile"
import { showMessage } from "../ducks/alerts"
import { createCashbox, fiscalCashbox, refresh } from "../ducks/cashbox"
import { createEmployee, getEmployees } from "../ducks/employees"
import { roleOptions } from "../config/permissions"
import StoreHolder from "../components/StoreHolder"
import StoreCard from "../components/StoreCard"
import Info from "../components/Info"
import firebase from "../config/firebaseConfig"
import "react-image-gallery/styles/css/image-gallery.css"
import bind from "bind-decorator"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
@connect(
  (state) => ({
    profile: state.profile,
    stores: state.profile.stores,
    cashbox: state.cashbox.data,
    currentStore: state.profile.currentStore,
    employees: state.employees.employees,
    storeOptions: state.profile.stores.map((s) => ({
      value: s.id,
      text: s.name,
      name: s.name,
      key: s.id,
      address: s.address,
    })),
    userData: state.userData,
  }),
  (dispatch) => ({
    selectStore: (id) => dispatch(selectStore(id)),
    createStore: (storeData) => dispatch(createStore(storeData)),
    createCashbox: (...data) => dispatch(createCashbox(...data)),
    selectCashbox: () => dispatch(refresh()),
    fiscalCashbox: (data) => dispatch(fiscalCashbox(data)),
    createEmployee: (data) => dispatch(createEmployee(data)),
    getEmployees: () => dispatch(getEmployees()),
    getStores: () => dispatch(getStores()),
    deleteStore: (storeid) => dispatch(deleteStore(storeid)),
    editStore: (data) => dispatch(editStore(data)),
    showMessage: (m, t) => dispatch(showMessage(m, t)),
    closeFirstEntry: (data) => dispatch(closeFirstEntry(data)),
    onSignIn: (...data) => dispatch(signIn(...data)),
    onSignOut: () => dispatch(signOut()),
    changeFirstEntry: (value) => dispatch(changeFirstEntryFunction(value)),
  }),
)
export default class SelectStorePage extends React.Component {
  state = {
    creating: false,
    open: true,
    step: 1,
    storeName: "",
    storeAddress: "",
    cashboxName: "",
    wkLogin: "",
    wkPass: "",
    serialNumber: "",
    npfu: "",
    employeeLogin: "",
    firstName: "",
    lastName: "",
    middleName: "",
    phone: "",
    pass: "",
    roles: [],
    storesState: [],
    selectStores:
      this.props.storeOptions.length > 0
        ? this.props.storeOptions[0].value
        : null,
    showCode: false,
    prevToFiscalAccess: false,
    prevToEmployeeAccess: false,
    wantFiskalize: false,
    wantAddEmployee: false,
  }

  componentDidMount() {
    const { getStores, selectCashbox, getEmployees } = this.props
    getStores()
    selectCashbox()
    getEmployees()
    // this.props.changeFirstEntry(true)
    if (this.props.stores.length > 0 && this.props.profile.firstEntry) {
      this.props.changeFirstEntry(false)
    }
  }

  @bind
  onStartCreating() {
    this.setState({
      creating: true,
    })
  }

  @bind
  cancelCreating() {
    this.setState({
      creating: false,
      open: false,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange(e) {
    const { showMessage, t } = this.props
    this.setState({
      [e.target.name]: e.target.value,
    })
    if (e.target.name === "pass") {
      if (e.target.value.length === 6) {
        this.setState({
          loading: true,
        })
        window.confirmationResult
          .confirm(e.target.value)
          .then((result) => {})
          .catch(function(error) {
            showMessage(t("Enter the correct password code"), "error")
          })
      }
    }
  }

  @bind
  handleModal() {
    this.setState({
      open: false,
    })
  }

  @bind
  handleSaveStore() {
    const { storeName, storeAddress } = this.state
    if (!storeName) {
      this.setState({
        storeNameError: true,
      })
    } else {
      this.setState({
        storeNameError: false,
      })
    }
    if (!storeAddress) {
      this.setState({
        storeAddressError: true,
      })
    } else {
      this.setState({
        storeAddressError: false,
      })
    }
    if (storeName && storeAddress) {
      // const data = {
      //   name: storeName,
      //   address: storeAddress,
      // }
      // this.props.createStore(data)
      this.setState({
        step: 2,
      })
    }
  }

  @bind
  handleSaveCashbox() {
    const { cashboxName, selectStores } = this.state
    if (!cashboxName) {
      this.setState({
        cashboxNameError: true,
      })
    } else {
      this.setState({
        cashboxNameError: false,
      })
    }
    if (cashboxName) {
      // const data = {
      //   name: cashboxName,
      //   store: selectStores,
      // }
      // this.props.createCashbox(data)
      this.setState({
        step: 3,
      })
    }
  }

  @bind
  handleFiscalCashbox() {
    const { wkLogin, wkPass, serialNumber, npfu } = this.state
    if (!wkLogin) {
      this.setState({
        wkLoginError: true,
      })
    } else {
      this.setState({
        wkLoginError: false,
      })
    }
    if (!wkPass) {
      this.setState({
        wkPassError: true,
      })
    } else {
      this.setState({
        wkPassError: false,
      })
    }
    if (!serialNumber) {
      this.setState({
        serialNumberError: true,
      })
    } else {
      this.setState({
        serialNumberError: false,
      })
    }
    if (!npfu) {
      this.setState({
        npfuError: true,
      })
    } else {
      this.setState({
        npfuError: false,
      })
    }
    if (wkLogin && wkPass && serialNumber && npfu) {
      // const fiscalData = {
      //   id: this.props.cashbox[0].id,
      //   wklogin: wkLogin,
      //   wkpass: wkPass,
      //   serialNumber: serialNumber,
      //   npfu: npfu,
      // }
      // this.props.fiscalCashbox(fiscalData)
      this.setState(
        {
          step: 4,
          wannaFiscal: true,
        },
        () => {
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            "captcha",
            {
              size: "invisible",
            },
          )
        },
      )
    }
  }

  @bind
  handleNextEmployeePage() {
    this.setState(
      {
        step: 4,
        prevToFiscalAccess: true,
      },
      () => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "captcha",
          {
            size: "invisible",
          },
        )
      },
    )
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onRolesAndStoresChange({}, { value, name }) {
    this.setState({
      [name]: value,
    })
  }

  @bind
  handleCreateEmployee() {
    const {
      firstName,
      lastName,
      employeeLogin,
      middleName,
      pass,
      phone,
      roles,
    } = this.state
    if (!firstName) {
      this.setState({
        firstNameError: true,
      })
    } else {
      this.setState({
        firstNameError: false,
      })
    }
    if (!lastName) {
      this.setState({
        lastNameError: true,
      })
    } else {
      this.setState({
        lastNameError: false,
      })
    }
    if (!employeeLogin) {
      this.setState({
        employeeLoginError: true,
      })
    } else {
      this.setState({
        employeeLoginError: false,
      })
    }
    if (!middleName) {
      this.setState({
        middleNameError: true,
      })
    } else {
      this.setState({
        middleNameError: false,
      })
    }
    if (!pass) {
      this.setState({
        passError: true,
      })
    } else {
      this.setState({
        passError: false,
      })
    }
    if (!phone) {
      this.setState({
        phoneError: true,
      })
    } else {
      this.setState({
        phoneError: false,
      })
    }
    if (roles.length === 0) {
      this.setState({
        rolesError: true,
      })
    } else {
      this.setState({
        rolesError: false,
      })
    }
    if (
      firstName &&
      lastName &&
      employeeLogin &&
      middleName &&
      pass &&
      phone &&
      roles.length !== 0
    ) {
      // const data = {
      //   firstName: firstName,
      //   lastName: lastName,
      //   login: employeeLogin,
      //   middleName: middleName,
      //   pass: pass,
      //   phone: phone,
      //   roles: roles,
      //   stores: storesState,
      // }
      // this.props.createEmployee(data)
      this.setState({
        step: 5,
        wannaEmployee: true,
      })
    }
  }

  @bind
  handleSendNumber() {
    const { showMessage, t } = this.props
    let appVerifier = window.recaptchaVerifier
    firebase
      .auth()
      .signInWithPhoneNumber(this.state.phone, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult
        this.setState({ showCode: true })
        // this.props.showMessage("Пароль отправлен на указанный номер", "success")
      })
      .then(() =>
        showMessage(t("Password sent to the specified number"), "success"),
      )
      /* eslint handle-callback-err: "error" */
      .catch((error) => showMessage(error.message, "error"))
  }

  @bind
  handleNextFinishPage() {
    this.setState({
      step: 5,
      prevToEmployeeAccess: true,
    })
  }

  @bind
  handlePrevFiscalPage() {
    this.setState({
      step: 3,
      prevToFiscalAccess: false,
    })
  }

  @bind
  handlePrevEmployeePage() {
    this.setState({
      step: 4,
      prevToEmployeeAccess: false,
    })
  }

  @bind
  signInCallback() {
    this.setState({ isLoading: false })
  }

  @bind
  handleFinish() {
    const {
      storeName,
      storeAddress,
      cashboxName,
      wkLogin,
      wkPass,
      serialNumber,
      npfu,
      wannaFiscal,
      firstName,
      lastName,
      employeeLogin,
      middleName,
      pass,
      phone,
      roles,
      wannaEmployee,
    } = this.state
    const data = {
      storeName,
      storeAddress,
      cashboxName,
      wkLogin,
      wkPass,
      serialNumber,
      npfu,
      wannaFiscal,
      firstName,
      lastName,
      employeeLogin,
      middleName,
      pass,
      phone,
      roles,
      wannaEmployee,
    }
    this.props.closeFirstEntry(data)
    setTimeout(() => {
      this.props.onSignIn(
        this.props.profile.login,
        this.props.profile.pass,
        this.signInCallback,
      )
    }, 2000)
    this.props.history.push("/profile")
  }

  render() {
    const { t } = this.props
    const {
      creating,
      step,
      storeName,
      storeAddress,
      cashboxName,
      wkLogin,
      wkPass,
      serialNumber,
      npfu,
      employeeLogin,
      firstName,
      lastName,
      middleName,
      phone,
      pass,
      roles,
      showCode,
      prevToFiscalAccess,
      prevToEmployeeAccess,
    } = this.state
    const {
      stores,
      createStore,
      deleteStore,
      editStore,
      selectStore,
      currentStore,
      profile,
      onSignOut,
    } = this.props
    if (stores) {
      if (
        stores.length === 1 &&
        (currentStore === null || currentStore === undefined)
      ) {
        selectStore(stores[0].id)
      }
    }
    return (
      <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2 style={{ margin: 0 }}>
            {t("selectStorePage")}
            <Info
              text={
                <div>
                  <p>{t("In this section you can")}</p>
                  <ul>
                    <li>
                      {t(
                        "Choose a store, information about which you want to receive",
                      )}
                    </li>
                    <li>{t("Create new stores")}</li>
                    <li>{t("Edit store names and addresses")}</li>
                    <li>{t("Delete existing stores")}</li>
                  </ul>
                </div>
              }
            />
          </h2>
          <Button color="green" onClick={this.onStartCreating}>
            {t("add")}
          </Button>
        </div>
        {profile.firstEntry ? (
          <>
            {/* <h3>У вас нет магазинов</h3>
            <Button color="green" onClick={this.onStartCreating}>
              Добавить
            </Button> */}
            <Modal
              // closeIcon
              open={this.state.open}
              // onClose={this.handleModal}
              size="small"
              style={{
                position: "fixed",
                top: "10%",
              }}
            >
              <div style={{ right: "20px", top: "10px", position: "fixed" }}>
                <Button color="red" onClick={() => onSignOut()}>
                  {t("logout")}
                </Button>
              </div>
              <Header className="mainStepper">
                {step === 1 && (
                  <>
                    <div className="stepperGreen">1</div>
                    <div className="stepperLine" />
                    <div className="stepper">2</div>
                    <div className="stepperLine" />
                    <div className="stepper">3</div>
                    <div className="stepperLine" />
                    <div className="stepper">4</div>
                    <div className="stepperLine" />
                    <div className="stepper">5</div>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="stepperGreen">1</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">2</div>
                    <div className="stepperLine" />
                    <div className="stepper">3</div>
                    <div className="stepperLine" />
                    <div className="stepper">4</div>
                    <div className="stepperLine" />
                    <div className="stepper">5</div>
                  </>
                )}
                {step === 3 && (
                  <>
                    <div className="stepperGreen">1</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">2</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">3</div>
                    <div className="stepperLine" />
                    <div className="stepper">4</div>
                    <div className="stepperLine" />
                    <div className="stepper">5</div>
                  </>
                )}
                {step === 4 && (
                  <>
                    <div className="stepperGreen">1</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">2</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">3</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">4</div>
                    <div className="stepperLine" />
                    <div className="stepper">5</div>
                  </>
                )}
                {step === 5 && (
                  <>
                    <div className="stepperGreen">1</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">2</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">3</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">4</div>
                    <div className="stepperLineGreen" />
                    <div className="stepperGreen">5</div>
                  </>
                )}
              </Header>
              <Modal.Content scrolling>
                {step === 1 && (
                  <div>
                    <h3>
                      <b>{t("Shop Creation")}</b>
                      <Info
                        text={
                          <div>
                            {t("Select Storage Shop creation step 1 info")}
                          </div>
                        }
                      />
                    </h3>
                    <Form>
                      <Form.Input
                        label={t("storeName")}
                        name="storeName"
                        value={storeName || ""}
                        error={this.state.storeNameError}
                        onChange={this.onChange}
                        maxLength="100"
                      />
                      {this.state.storeNameError && (
                        <Label
                          basic
                          color="red"
                          pointing
                          style={{ marginTop: "-10px" }}
                        >
                          {t("requiredField")}
                        </Label>
                      )}
                      <Form.Input
                        label={t("storeAddress")}
                        name="storeAddress"
                        value={storeAddress || ""}
                        error={this.state.storeAddressError}
                        onChange={this.onChange}
                        maxLength="100"
                      />
                      {this.state.storeAddressError && (
                        <Label
                          basic
                          color="red"
                          pointing
                          style={{ marginTop: "-10px" }}
                        >
                          {t("requiredField")}
                        </Label>
                      )}
                      <p style={{ fontSize: "13px", marginTop: "-15px" }}>
                        *{" "}
                        {t(
                          "The address must match the address issued during registration with the tax authority",
                        )}
                      </p>
                    </Form>
                    <Button
                      onClick={this.handleSaveStore}
                      className="nextButton"
                    >
                      {t("next")}
                    </Button>
                  </div>
                )}
                {step === 2 && (
                  <div>
                    <h3>
                      <b>{t("Cash desk creation")}</b>
                      <Info
                        text={t(
                          "Creation of the first cash desk Name the cashier and select the store in which it is located",
                        )}
                      />
                    </h3>
                    <Form autoComplete="off">
                      <Form.Input
                        label={t("Cashbox name")}
                        type="text"
                        name="cashboxName"
                        error={this.state.cashboxNameError}
                        id="cashboxName"
                        value={cashboxName}
                        onChange={this.onChange}
                        maxLength="50"
                      />
                      {this.state.cashboxNameError && (
                        <Label
                          basic
                          color="red"
                          pointing
                          style={{ marginTop: "-10px" }}
                        >
                          {t("requiredField")}
                        </Label>
                      )}
                      <Form.Input
                        label={t("store")}
                        name="selectStores"
                        value={storeName}
                        disabled
                      />
                    </Form>
                    <Button
                      onClick={this.handleSaveCashbox}
                      className="nextButton"
                    >
                      {t("next")}
                    </Button>
                  </div>
                )}
                {step === 3 &&
                  (this.state.wantFiscalize ? (
                    <>
                      <div>
                        <h3>
                          <b>{t("Fiscalize cashbox")}</b>
                          <Info
                            text={
                              <div>
                                <p>
                                  {t(
                                    "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier",
                                  )}{" "}
                                </p>
                                <p>{t("Prerequisites for Fiscalization")}</p>
                                <ul>
                                  <li>
                                    {t(
                                      "cash register must be registered with the tax authority",
                                    )}
                                  </li>
                                  <li>
                                    {t(
                                      "account on the Webkassa service (paid separately on the website wwwwebkassakz)",
                                    )}
                                  </li>
                                  <li>
                                    {t(
                                      "CRF account (paid separately on the website wwwoofdkz)",
                                    )}
                                  </li>
                                </ul>
                              </div>
                            }
                          />
                        </h3>
                        <Form>
                          <Form.Input
                            label="Логин (Webkassa)"
                            type="text"
                            name="wkLogin"
                            error={this.state.wkLoginError}
                            id="wkLogin"
                            value={wkLogin}
                            onChange={this.onChange}
                            maxLength="50"
                          />
                          {this.state.wkLoginError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            label="Пароль (Webkassa)"
                            type="password"
                            name="wkPass"
                            error={this.state.wkPassError}
                            id="wkPass"
                            value={wkPass}
                            onChange={this.onChange}
                            maxLength="50"
                          />
                          {this.state.wkPassError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            label={t("serialNumber")}
                            type="text"
                            name="serialNumber"
                            error={this.state.serialNumberError}
                            value={serialNumber}
                            onChange={this.onChange}
                            maxLength="50"
                          />
                          {this.state.serialNumberError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            label={t("registerIdCashbox")}
                            type="text"
                            name="npfu"
                            error={this.state.npfuError}
                            value={npfu}
                            onChange={this.onChange}
                            maxLength="50"
                          />
                          {this.state.npfuError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                        </Form>
                        <Button
                          className="fiscalButton"
                          onClick={this.handleFiscalCashbox}
                        >
                          {t("To Fiscalize")}
                        </Button>
                        <Button
                          className="sendButton"
                          onClick={this.handleNextEmployeePage}
                        >
                          {t("skip")}
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <h3>Хотите Фискализировать кассу прямо сейчас</h3>
                      <Button
                        positive
                        content={t("yes")}
                        onClick={() => this.setState({ wantFiscalize: true })}
                      />
                      <Button
                        positive
                        content={t("no")}
                        onClick={() => this.setState({ step: 4 })}
                      />
                    </>
                  ))}
                {step === 4 &&
                  (this.state.wantAddEmployee ? (
                    <>
                      <div>
                        <h3>
                          <b>{t("Create employee")}</b>
                          <Info
                            text={
                              <div>
                                <p>{t("To register an employee, you need:")}</p>
                                <ul>
                                  <li>{t("IIN employee and")}</li>
                                  <li>
                                    {t(
                                      "employee's cell phone number This number will receive the employee password to log into the Smartkassa system",
                                    )}
                                  </li>
                                </ul>
                              </div>
                            }
                          />
                        </h3>
                        <Form>
                          <InputMask
                            mask="999999999999"
                            value={employeeLogin || ""}
                            onChange={this.onChange}
                          >
                            {(inputProps) => (
                              <Form.Input
                                {...inputProps}
                                label={t("UIN")}
                                type="text"
                                name="employeeLogin"
                                error={this.state.employeeLoginError}
                              />
                            )}
                          </InputMask>
                          {this.state.employeeLoginError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          {/* <Form.Input
                        label="ИИН"
                        type="text"
                        name="employeeLogin"
                        value={employeeLogin || ""}
                        onChange={this.onChange}
                      /> */}
                          <Form.Input
                            label={t("lastname")}
                            type="text"
                            name="lastName"
                            value={lastName || ""}
                            onChange={this.onChange}
                            error={this.state.lastNameError}
                            maxLength="20"
                          />
                          {this.state.lastNameError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            label={t("firstname")}
                            type="text"
                            name="firstName"
                            value={firstName || ""}
                            onChange={this.onChange}
                            error={this.state.firstNameError}
                            maxLength="20"
                          />
                          {this.state.firstNameError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            label={t("middlename")}
                            type="text"
                            id="mdl"
                            name="middleName"
                            value={middleName || ""}
                            onChange={this.onChange}
                            error={this.state.middleNameError}
                            maxLength="30"
                          />
                          {this.state.middleNameError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <div>
                            <InputMask
                              mask="+7\ 999 999 99 99"
                              value={phone || "+7"}
                              onChange={this.onChange}
                            >
                              {(inputProps) => (
                                <Form.Input
                                  {...inputProps}
                                  label={t("phoneNumber")}
                                  name="phone"
                                  type="text"
                                  style={{ width: "65%", float: "left" }}
                                  error={this.state.phoneError}
                                />
                              )}
                            </InputMask>
                            {this.state.phoneError && (
                              <Label
                                basic
                                color="red"
                                pointing
                                // style={{ marginTop: "-10px" }}
                              >
                                {t("requiredField")}
                              </Label>
                            )}
                          </div>
                          {/* <Form.Input
                          label="Номер телефона"
                          type="text"
                          name="phone"
                          value={phone || ""}
                          style={{ width: "70%" }}
                          onChange={this.onChange}
                        /> */}
                          <div>
                            <Button
                              style={{ width: "30%", float: "right" }}
                              color="green"
                              content={t("Submit Code")}
                              id="captcha"
                              onClick={this.handleSendNumber}
                            />
                          </div>
                          {showCode ? (
                            <>
                              <Form.Input
                                label="Пароль"
                                type="password"
                                name="pass"
                                value={pass || ""}
                                onChange={this.onChange}
                                error={this.state.passError}
                                maxLength="20"
                              />
                              {this.state.passError && (
                                <Label
                                  basic
                                  color="red"
                                  pointing
                                  style={{ marginTop: "-10px" }}
                                >
                                  {t("requiredField")}
                                </Label>
                              )}
                              <p
                                style={{
                                  fontSize: "13px",
                                  marginTop: "-15px",
                                  color: "grey",
                                }}
                              >
                                *{" "}
                                {t("Password was sent to the specified number")}
                              </p>
                            </>
                          ) : null}
                          <Form.Select
                            multiple
                            label={t("roles")}
                            name="roles"
                            value={roles}
                            options={roleOptions}
                            onChange={this.onRolesAndStoresChange}
                            error={this.state.rolesError}
                          />
                          {this.state.rolesError && (
                            <Label
                              basic
                              color="red"
                              pointing
                              style={{ marginTop: "-10px" }}
                            >
                              {t("requiredField")}
                            </Label>
                          )}
                          <Form.Input
                            multiple
                            label={t("store").capitalize()}
                            name="storesState"
                            value={storeName}
                            disabled
                          />
                        </Form>
                        {prevToFiscalAccess && (
                          <Button
                            className="prevButton"
                            onClick={this.handlePrevFiscalPage}
                          >
                            {t("back")}
                          </Button>
                        )}
                        <Button
                          className="sendButton"
                          onClick={this.handleCreateEmployee}
                        >
                          {t("create")}
                        </Button>
                        <Button
                          className="sendButton"
                          onClick={this.handleNextFinishPage}
                        >
                          {t("skip")}
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <h3>Хотите добавить сотрудника сейчас?</h3>
                      <Button
                        content={t("yes")}
                        onClick={() => this.setState({ wantAddEmployee: true })}
                        positive
                      />
                      <Button
                        content={t("no")}
                        onClick={this.handleNextFinishPage}
                        positive
                      />
                    </>
                  ))}
                {step === 5 && (
                  <div>
                    <table>
                      <tr>
                        <td>
                          <b>{t("store").capitalize()}: </b>
                        </td>
                        <td>{storeName}</td>
                        <td>
                          <b>Касса: </b>
                        </td>
                        <td>{cashboxName}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>{t("addressStore")}: </b>
                        </td>
                        <td>{storeAddress}</td>
                        {employeeLogin && (
                          <>
                            <td>
                              <b>{t("employe")}: </b>
                            </td>
                            <td>
                              {lastName} {firstName} {middleName}
                            </td>
                          </>
                        )}
                      </tr>
                    </table>
                    {prevToEmployeeAccess && (
                      <Button
                        className="prevButton"
                        onClick={this.handlePrevEmployeePage}
                      >
                        {t("back")}
                      </Button>
                    )}
                    <Button className="sendButton" onClick={this.handleFinish}>
                      {t("toComplete")}
                    </Button>
                  </div>
                )}
              </Modal.Content>
            </Modal>
            {/* <h3>У Вас нет магазинов</h3>
            <Button color="green" onClick={this.onStartCreating}>
              Добавить
            </Button> */}
            {creating && (
              <Grid style={{ marginTop: "5px" }}>
                <Grid.Row>
                  <Grid.Column computer={8} tablet={16}>
                    <StoreCard
                      createStore={createStore}
                      cancelCreating={this.cancelCreating}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </>
        ) : (
          <Container className="select-store-page" text>
            {creating && (
              <Grid style={{ marginTop: "5px" }}>
                <Grid.Row>
                  <Grid.Column computer={8} tablet={16}>
                    <StoreCard
                      createStore={createStore}
                      cancelCreating={this.cancelCreating}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
            <h2>{t("chooseStore")}</h2>
            {stores.length ? (
              <StoreHolder
                stores={stores}
                currentStore={currentStore}
                deleteStore={deleteStore}
                editStore={editStore}
                selectStore={selectStore}
              />
            ) : (
              <Dimmer active>
                <Loader />
              </Dimmer>
            )}
            {/* {data} */}
          </Container>
        )}
      </>
    )
  }
}

// import React from "react"
// import {
//   Container,
//   Modal,
//   Button,
//   Header,
//   Form,
//   Grid,
//   Label,
// } from "semantic-ui-react"
// import InputMask from "react-input-mask"
// import { connect } from "react-redux"
// import {
//   selectStore,
//   createStore,
//   getStores,
//   deleteStore,
//   editStore,
//   closeFirstEntry,
//   signIn,
//   signOut,
// } from "../ducks/profile"
// import { showMessage } from "../ducks/alerts"
// import { createCashbox, fiscalCashbox, refresh } from "../ducks/cashbox"
// import { createEmployee, getEmployees } from "../ducks/employees"
// import { roleOptions } from "../config/permissions"
// import StoreHolder from "../components/StoreHolder"
// import StoreCard from "../components/StoreCard"
// import Info from "../components/Info"
// import firebase from "../config/firebaseConfig"
// import "react-image-gallery/styles/css/image-gallery.css"
// import bind from "bind-decorator"
// import { withRouter } from "react-router-dom"
// // import { withTranslation } from "react-i18next"

// @withRouter
// @connect(
//   (state) => ({
//     profile: state.profile,
//     stores: state.profile.stores,
//     cashbox: state.cashbox.data,
//     currentStore: state.profile.currentStore,
//     employees: state.employees.employees,
//     storeOptions: state.profile.stores.map((s) => ({
//       value: s.id,
//       text: s.name,
//       name: s.name,
//       key: s.id,
//       address: s.address,
//     })),
//     userData: state.userData,
//   }),
//   (dispatch) => ({
//     selectStore: (id) => dispatch(selectStore(id)),
//     createStore: (storeData) => dispatch(createStore(storeData)),
//     createCashbox: (...data) => dispatch(createCashbox(...data)),
//     selectCashbox: () => dispatch(refresh()),
//     fiscalCashbox: (data) => dispatch(fiscalCashbox(data)),
//     createEmployee: (data) => dispatch(createEmployee(data)),
//     getEmployees: () => dispatch(getEmployees()),
//     getStores: () => dispatch(getStores()),
//     deleteStore: (storeid) => dispatch(deleteStore(storeid)),
//     editStore: (data) => dispatch(editStore(data)),
//     showMessage: (m, t) => dispatch(showMessage(m, t)),
//     closeFirstEntry: (data) => dispatch(closeFirstEntry(data)),
//     onSignIn: (...data) => dispatch(signIn(...data)),
//     onSignOut: () => dispatch(signOut()),
//   }),
// )
// class SelectStorePage extends React.Component {
//   state = {
//     creating: false,
//     open: true,
//     step: 1,
//     storeName: "",
//     storeAddress: "",
//     cashboxName: "",
//     wkLogin: "",
//     wkPass: "",
//     serialNumber: "",
//     npfu: "",
//     employeeLogin: "",
//     firstName: "",
//     lastName: "",
//     middleName: "",
//     phone: "",
//     pass: "",
//     roles: [],
//     storesState: [],
//     selectStores:
//       this.props.storeOptions.length > 0
//         ? this.props.storeOptions[0].value
//         : null,
//     showCode: false,
//     prevToFiscalAccess: false,
//     prevToEmployeeAccess: false,
//     wannaFiscal: false,
//     wannaEmployee: false,
//   }

//   componentDidMount() {
//     const { getStores, selectCashbox, getEmployees } = this.props
//     getStores()
//     selectCashbox()
//     getEmployees()
//   }

//   @bind
//   onStartCreating() {
//     this.setState({
//       creating: true,
//     })
//   }

//   @bind
//   cancelCreating() {
//     this.setState({
//       creating: false,
//       open: false,
//     })
//   }

//   @bind
//   // eslint-disable-next-line no-empty-pattern
//   onChange(e) {
//     const { showMessage } = this.props
//     this.setState({
//       [e.target.name]: e.target.value,
//     })
//     if (e.target.name === "pass") {
//       if (e.target.value.length === 6) {
//         this.setState({
//           loading: true,
//         })
//         window.confirmationResult
//           .confirm(e.target.value)
//           .then((result) => {
//           })
//           .catch(function(error) {
//             showMessage("Введите корректный код-пароль", "error")
//           })
//       }
//     }
//   }

//   @bind
//   handleModal() {
//     this.setState({
//       open: false,
//     })
//   }

//   @bind
//   handleSaveStore() {
//     const { storeName, storeAddress } = this.state
//     if (!storeName) {
//       this.setState({
//         storeNameError: true,
//       })
//     } else {
//       this.setState({
//         storeNameError: false,
//       })
//     }
//     if (!storeAddress) {
//       this.setState({
//         storeAddressError: true,
//       })
//     } else {
//       this.setState({
//         storeAddressError: false,
//       })
//     }
//     if (storeName && storeAddress) {
//       // const data = {
//       //   name: storeName,
//       //   address: storeAddress,
//       // }
//       // this.props.createStore(data)
//       this.setState({
//         step: 2,
//       })
//     }
//   }

//   @bind
//   handleSaveCashbox() {
//     const { cashboxName, selectStores } = this.state
//     if (!cashboxName) {
//       this.setState({
//         cashboxNameError: true,
//       })
//     } else {
//       this.setState({
//         cashboxNameError: false,
//       })
//     }
//     if (cashboxName) {
//       // const data = {
//       //   name: cashboxName,
//       //   store: selectStores,
//       // }
//       // this.props.createCashbox(data)
//       this.setState({
//         step: 3,
//       })
//     }
//   }

//   @bind
//   handleFiscalCashbox() {
//     const { wkLogin, wkPass, serialNumber, npfu } = this.state
//     if (!wkLogin) {
//       this.setState({
//         wkLoginError: true,
//       })
//     } else {
//       this.setState({
//         wkLoginError: false,
//       })
//     }
//     if (!wkPass) {
//       this.setState({
//         wkPassError: true,
//       })
//     } else {
//       this.setState({
//         wkPassError: false,
//       })
//     }
//     if (!serialNumber) {
//       this.setState({
//         serialNumberError: true,
//       })
//     } else {
//       this.setState({
//         serialNumberError: false,
//       })
//     }
//     if (!npfu) {
//       this.setState({
//         npfuError: true,
//       })
//     } else {
//       this.setState({
//         npfuError: false,
//       })
//     }
//     if (wkLogin && wkPass && serialNumber && npfu) {
//       // const fiscalData = {
//       //   id: this.props.cashbox[0].id,
//       //   wklogin: wkLogin,
//       //   wkpass: wkPass,
//       //   serialNumber: serialNumber,
//       //   npfu: npfu,
//       // }
//       // this.props.fiscalCashbox(fiscalData)
//       this.setState(
//         {
//           step: 4,
//           wannaFiscal: true,
//         },
//         () => {
//           window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
//             "captcha",
//             {
//               size: "invisible",
//             },
//           )
//         },
//       )
//     }
//   }

//   @bind
//   handleNextEmployeePage() {
//     this.setState(
//       {
//         step: 4,
//         prevToFiscalAccess: true,
//       },
//       () => {
//         window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
//           "captcha",
//           {
//             size: "invisible",
//           },
//         )
//       },
//     )
//   }

//   @bind
//   // eslint-disable-next-line no-empty-pattern
//   onRolesAndStoresChange({}, { value, name }) {
//     this.setState({
//       [name]: value,
//     })
//   }

//   @bind
//   handleCreateEmployee() {
//     const {
//       firstName,
//       lastName,
//       employeeLogin,
//       middleName,
//       pass,
//       phone,
//       roles,
//     } = this.state
//     if (!firstName) {
//       this.setState({
//         firstNameError: true,
//       })
//     } else {
//       this.setState({
//         firstNameError: false,
//       })
//     }
//     if (!lastName) {
//       this.setState({
//         lastNameError: true,
//       })
//     } else {
//       this.setState({
//         lastNameError: false,
//       })
//     }
//     if (!employeeLogin) {
//       this.setState({
//         employeeLoginError: true,
//       })
//     } else {
//       this.setState({
//         employeeLoginError: false,
//       })
//     }
//     if (!middleName) {
//       this.setState({
//         middleNameError: true,
//       })
//     } else {
//       this.setState({
//         middleNameError: false,
//       })
//     }
//     if (!pass) {
//       this.setState({
//         passError: true,
//       })
//     } else {
//       this.setState({
//         passError: false,
//       })
//     }
//     if (!phone) {
//       this.setState({
//         phoneError: true,
//       })
//     } else {
//       this.setState({
//         phoneError: false,
//       })
//     }
//     if (roles.length === 0) {
//       this.setState({
//         rolesError: true,
//       })
//     } else {
//       this.setState({
//         rolesError: false,
//       })
//     }
//     if (
//       firstName &&
//       lastName &&
//       employeeLogin &&
//       middleName &&
//       pass &&
//       phone &&
//       roles.length !== 0
//     ) {
//       // const data = {
//       //   firstName: firstName,
//       //   lastName: lastName,
//       //   login: employeeLogin,
//       //   middleName: middleName,
//       //   pass: pass,
//       //   phone: phone,
//       //   roles: roles,
//       //   stores: storesState,
//       // }
//       // this.props.createEmployee(data)
//       this.setState({
//         step: 5,
//         wannaEmployee: true,
//       })
//     }
//   }

//   @bind
//   handleSendNumber() {
//     const { showMessage } = this.props
//     let appVerifier = window.recaptchaVerifier
//     firebase
//       .auth()
//       .signInWithPhoneNumber(this.state.phone, appVerifier)
//       .then((confirmationResult) => {
//         window.confirmationResult = confirmationResult
//         this.setState({ showCode: true })
//         // this.props.showMessage("Пароль отправлен на указанный номер", "success")
//       })
//       .then(() => showMessage("Пароль отправлен на указанный номер", "success"))
//       /* eslint handle-callback-err: "error" */
//       .catch((error) => showMessage(error.message, "error"))
//   }

//   @bind
//   handleNextFinishPage() {
//     this.setState({
//       step: 5,
//       prevToEmployeeAccess: true,
//     })
//   }

//   @bind
//   handlePrevFiscalPage() {
//     this.setState({
//       step: 3,
//       prevToFiscalAccess: false,
//     })
//   }

//   @bind
//   handlePrevEmployeePage() {
//     this.setState({
//       step: 4,
//       prevToEmployeeAccess: false,
//     })
//   }

//   @bind
//   signInCallback() {
//     this.setState({ isLoading: false })
//   }

//   @bind
//   handleFinish() {
//     const {
//       storeName,
//       storeAddress,
//       cashboxName,
//       wkLogin,
//       wkPass,
//       serialNumber,
//       npfu,
//       wannaFiscal,
//       firstName,
//       lastName,
//       employeeLogin,
//       middleName,
//       pass,
//       phone,
//       roles,
//       wannaEmployee,
//     } = this.state
//     const data = {
//       storeName,
//       storeAddress,
//       cashboxName,
//       wkLogin,
//       wkPass,
//       serialNumber,
//       npfu,
//       wannaFiscal,
//       firstName,
//       lastName,
//       employeeLogin,
//       middleName,
//       pass,
//       phone,
//       roles,
//       wannaEmployee,
//     }
//     this.props.closeFirstEntry(data)
//     setTimeout(() => {
//       this.props.onSignIn(
//         this.props.profile.login,
//         this.props.profile.pass,
//         this.signInCallback,
//       )
//     }, 2000)
//     this.props.history.push("/profile")
//   }

//   render() {
//     const { t } = this.props
//     const {
//       creating,
//       step,
//       storeName,
//       storeAddress,
//       cashboxName,
//       wkLogin,
//       wkPass,
//       serialNumber,
//       npfu,
//       employeeLogin,
//       firstName,
//       lastName,
//       middleName,
//       phone,
//       pass,
//       roles,
//       showCode,
//       prevToFiscalAccess,
//       prevToEmployeeAccess,
//     } = this.state
//     const {
//       stores,
//       createStore,
//       deleteStore,
//       editStore,
//       selectStore,
//       currentStore,
//       profile,
//       onSignOut,
//     } = this.props
//     if (stores) {
//       if (
//         stores.length === 1 &&
//         (currentStore === null || currentStore === undefined)
//       ) {
//         selectStore(stores[0].id)
//       }
//     }
//     return (
//       <>
//         <h2 style={{ margin: 0 }}>
//           {"Магазины"}
//           <Info
//             text={
//               <div>
//                 <p>В данном разделе вы можете:</p>
//                 <ul>
//                   <li>
//                     Выбирать магазин, информацию о котором вы хотите получить
//                   </li>
//                   <li>Создавать новые магазины</li>
//                   <li>Редактировать названия и адреса магазинов</li>
//                   <li>Удалять существующие магазины</li>
//                 </ul>
//               </div>
//             }
//           />
//         </h2>
//         {profile.firstEntry ? (
//           <>
//             {/* <h3>У вас нет магазинов</h3>
//             <Button color="green" onClick={this.onStartCreating}>
//               Добавить
//             </Button> */}
//             <Modal
//               // closeIcon
//               open={this.state.open}
//               // onClose={this.handleModal}
//               size="small"
//               style={{
//                 position: "fixed",
//                 top: "10%",
//               }}
//             >
//               <div style={{ right: "20px", top: "10px", position: "fixed" }}>
//                 <Button color="red" onClick={() => onSignOut()}>
//                   Выйти
//                 </Button>
//               </div>
//               <Header className="mainStepper">
//                 {step === 1 && (
//                   <>
//                     <div className="stepperGreen">1</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">2</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">3</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">4</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">5</div>
//                   </>
//                 )}
//                 {step === 2 && (
//                   <>
//                     <div className="stepperGreen">1</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">2</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">3</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">4</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">5</div>
//                   </>
//                 )}
//                 {step === 3 && (
//                   <>
//                     <div className="stepperGreen">1</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">2</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">3</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">4</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">5</div>
//                   </>
//                 )}
//                 {step === 4 && (
//                   <>
//                     <div className="stepperGreen">1</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">2</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">3</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">4</div>
//                     <div className="stepperLine" />
//                     <div className="stepper">5</div>
//                   </>
//                 )}
//                 {step === 5 && (
//                   <>
//                     <div className="stepperGreen">1</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">2</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">3</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">4</div>
//                     <div className="stepperLineGreen" />
//                     <div className="stepperGreen">5</div>
//                   </>
//                 )}
//               </Header>
//               <Modal.Content scrolling>
//                 {step === 1 && (
//                   <div>
//                     <h3>
//                       <b>Создание магазина</b>
//                       <Info
//                         text={
//                           <div>
//                             Задайте название и адрес магазина. Обратите
//                             внимание, что вы задаете название конкретной точки
//                             продажи (впоследствии вы сможете изменить название).
//                             Адрес должен совпадать с адресом, выданным при
//                             регистрации в налоговом органе
//                           </div>
//                         }
//                       />
//                     </h3>
//                     <Form>
//                       <Form.Input
//                         label="Название магазина"
//                         name="storeName"
//                         value={storeName || ""}
//                         error={this.state.storeNameError}
//                         onChange={this.onChange}
//                         maxLength="100"
//                       />
//                       {this.state.storeNameError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Адрес магазина"
//                         name="storeAddress"
//                         value={storeAddress || ""}
//                         error={this.state.storeAddressError}
//                         onChange={this.onChange}
//                         maxLength="100"
//                       />
//                       {this.state.storeAddressError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <p style={{ fontSize: "13px", marginTop: "-15px" }}>
//                         * Адрес должен совпадать с адресом, выданным при
//                         регистрации в налоговом органе
//                       </p>
//                     </Form>
//                     <Button
//                       onClick={this.handleSaveStore}
//                       className="nextButton"
//                     >
//                       Далее
//                     </Button>
//                   </div>
//                 )}
//                 {step === 2 && (
//                   <div>
//                     <h3>
//                       <b>Создание кассы</b>
//                       <Info text="Создание первой кассы. Задайте название кассы и выберите магазин, в котором она находится" />
//                     </h3>
//                     <Form autoComplete="off">
//                       <Form.Input
//                         label="Название кассы"
//                         type="text"
//                         name="cashboxName"
//                         error={this.state.cashboxNameError}
//                         id="cashboxName"
//                         value={cashboxName}
//                         onChange={this.onChange}
//                         maxLength="50"
//                       />
//                       {this.state.cashboxNameError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Магазин"
//                         name="selectStores"
//                         value={storeName}
//                         disabled
//                       />
//                     </Form>
//                     <Button
//                       onClick={this.handleSaveCashbox}
//                       className="nextButton"
//                     >
//                       Далее
//                     </Button>
//                   </div>
//                 )}
//                 {step === 3 && (
//                   <div>
//                     <h3>
//                       <b>Фискализация кассы</b>
//                       <Info
//                         text={
//                           <div>
//                             <p>
//                               Обратите внимание, что если у вас имеется
//                               физическая касса - вы можете работать со
//                               Smartkassa в нефискальном режиме, печатая чеки
//                               через вашу физическую кассу.{" "}
//                             </p>
//                             <p>Необходимые условия для фискализации:</p>
//                             <ul>
//                               <li>
//                                 касса должна быть зарегистрирована в налоговом
//                                 органе
//                               </li>
//                               <li>
//                                 аккаунт на сервисе Webkassa (оплачивается
//                                 отдельно на сайте www.webkassa.kz)
//                               </li>
//                               <li>
//                                 аккаунт ОФД (оплачивается отдельно на сайте
//                                 www.oofd.kz)
//                               </li>
//                             </ul>
//                           </div>
//                         }
//                       />
//                     </h3>
//                     <Form>
//                       <Form.Input
//                         label="Логин (Оператор ККМ)"
//                         type="text"
//                         name="wkLogin"
//                         error={this.state.wkLoginError}
//                         id="wkLogin"
//                         value={wkLogin}
//                         onChange={this.onChange}
//                         maxLength="50"
//                       />
//                       {this.state.wkLoginError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Пароль (Оператор ККМ)"
//                         type="password"
//                         name="wkPass"
//                         error={this.state.wkPassError}
//                         id="wkPass"
//                         value={wkPass}
//                         onChange={this.onChange}
//                         maxLength="50"
//                       />
//                       {this.state.wkPassError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Серийный номер"
//                         type="text"
//                         name="serialNumber"
//                         error={this.state.serialNumberError}
//                         value={serialNumber}
//                         onChange={this.onChange}
//                         maxLength="50"
//                       />
//                       {this.state.serialNumberError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Регистрационный номер кассы"
//                         type="text"
//                         name="npfu"
//                         error={this.state.npfuError}
//                         value={npfu}
//                         onChange={this.onChange}
//                         maxLength="50"
//                       />
//                       {this.state.npfuError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                     </Form>
//                     <Button
//                       className="fiscalButton"
//                       onClick={this.handleFiscalCashbox}
//                     >
//                       Фискализировать
//                     </Button>
//                     <Button
//                       className="sendButton"
//                       onClick={this.handleNextEmployeePage}
//                     >
//                       Пропустить
//                     </Button>
//                   </div>
//                 )}
//                 {step === 4 && (
//                   <div>
//                     <h3>
//                       <b>Создание сотрудника</b>
//                       <Info
//                         text={
//                           <div>
//                             <p>Для регистрации сотрудника необходимы:</p>
//                             <ul>
//                               <li>ИИН сотрудника и</li>
//                               <li>
//                                 сотовый номер телефона сотрудника. На этот номер
//                                 поступит пароль сотрудника для входа в систему
//                                 Smartkassa.
//                               </li>
//                             </ul>
//                           </div>
//                         }
//                       />
//                     </h3>
//                     <Form>
//                       <InputMask
//                         mask="999999999999"
//                         value={employeeLogin || ""}
//                         onChange={this.onChange}
//                       >
//                         {(inputProps) => (
//                           <Form.Input
//                             {...inputProps}
//                             label="ИИН"
//                             type="text"
//                             name="employeeLogin"
//                             error={this.state.employeeLoginError}
//                             maxLength="12"
//                           />
//                         )}
//                       </InputMask>
//                       {this.state.employeeLoginError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       {/* <Form.Input
//                         label="ИИН"
//                         type="text"
//                         name="employeeLogin"
//                         value={employeeLogin || ""}
//                         onChange={this.onChange}
//                       /> */}
//                       <Form.Input
//                         label="Фамилия"
//                         type="text"
//                         name="lastName"
//                         value={lastName || ""}
//                         onChange={this.onChange}
//                         error={this.state.lastNameError}
//                         maxLength="20"
//                       />
//                       {this.state.lastNameError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Имя"
//                         type="text"
//                         name="firstName"
//                         value={firstName || ""}
//                         onChange={this.onChange}
//                         error={this.state.firstNameError}
//                         maxLength="20"
//                       />
//                       {this.state.firstNameError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         label="Отчество"
//                         type="text"
//                         id="mdl"
//                         name="middleName"
//                         value={middleName || ""}
//                         onChange={this.onChange}
//                         error={this.state.middleNameError}
//                         maxLength="30"
//                       />
//                       {this.state.middleNameError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <div>
//                         <InputMask
//                           mask="+7\ 999 999 99 99"
//                           value={phone || "+7"}
//                           onChange={this.onChange}
//                         >
//                           {(inputProps) => (
//                             <Form.Input
//                               {...inputProps}
//                               label="Номер телефона"
//                               name="phone"
//                               type="text"
//                               style={{ width: "65%", float: "left" }}
//                               error={this.state.phoneError}
//                             />
//                           )}
//                         </InputMask>
//                         {this.state.phoneError && (
//                           <Label
//                             basic
//                             color="red"
//                             pointing
//                             // style={{ marginTop: "-10px" }}
//                           >
//                             Поле обязательно для заполнения
//                           </Label>
//                         )}
//                       </div>
//                       {/* <Form.Input
//                           label="Номер телефона"
//                           type="text"
//                           name="phone"
//                           value={phone || ""}
//                           style={{ width: "70%" }}
//                           onChange={this.onChange}
//                         /> */}
//                       <div>
//                         <Button
//                           style={{ width: "30%", float: "right" }}
//                           color="green"
//                           content="Отправить код"
//                           id="captcha"
//                           onClick={this.handleSendNumber}
//                         />
//                       </div>
//                       {showCode ? (
//                         <>
//                           <Form.Input
//                             label="Пароль"
//                             type="password"
//                             name="pass"
//                             value={pass || ""}
//                             onChange={this.onChange}
//                             error={this.state.passError}
//                             maxLength="20"
//                           />
//                           {this.state.passError && (
//                             <Label
//                               basic
//                               color="red"
//                               pointing
//                               style={{ marginTop: "-10px" }}
//                             >
//                               Поле обязательно для заполнения
//                             </Label>
//                           )}
//                           <p
//                             style={{
//                               fontSize: "13px",
//                               marginTop: "-15px",
//                               color: "grey",
//                             }}
//                           >
//                             * Пароль был отправлен на указанный номер
//                           </p>
//                         </>
//                       ) : null}
//                       <Form.Select
//                         multiple
//                         label="Права"
//                         name="roles"
//                         value={roles}
//                         options={roleOptions}
//                         onChange={this.onRolesAndStoresChange}
//                         error={this.state.rolesError}
//                       />
//                       {this.state.rolesError && (
//                         <Label
//                           basic
//                           color="red"
//                           pointing
//                           style={{ marginTop: "-10px" }}
//                         >
//                           Поле обязательно для заполнения
//                         </Label>
//                       )}
//                       <Form.Input
//                         multiple
//                         label="Магазин"
//                         name="storesState"
//                         value={storeName}
//                         disabled
//                       />
//                     </Form>
//                     {prevToFiscalAccess && (
//                       <Button
//                         className="prevButton"
//                         onClick={this.handlePrevFiscalPage}
//                       >
//                         Назад
//                       </Button>
//                     )}
//                     <Button
//                       className="sendButton"
//                       onClick={this.handleCreateEmployee}
//                     >
//                       Создать
//                     </Button>
//                     <Button
//                       className="sendButton"
//                       onClick={this.handleNextFinishPage}
//                     >
//                       Пропустить
//                     </Button>
//                   </div>
//                 )}
//                 {step === 5 && (
//                   <div>
//                     <table>
//                       <tr>
//                         <td>
//                           <b>Магазин: </b>
//                         </td>
//                         <td>{storeName}</td>
//                         <td>
//                           <b>Касса: </b>
//                         </td>
//                         <td>{cashboxName}</td>
//                       </tr>
//                       <tr>
//                         <td>
//                           <b>Адрес магазина: </b>
//                         </td>
//                         <td>{storeAddress}</td>
//                         {employeeLogin && (
//                           <>
//                             <td>
//                               <b>Сотрудник: </b>
//                             </td>
//                             <td>
//                               {lastName} {firstName} {middleName}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     </table>
//                     {prevToEmployeeAccess && (
//                       <Button
//                         className="prevButton"
//                         onClick={this.handlePrevEmployeePage}
//                       >
//                         Назад
//                       </Button>
//                     )}
//                     <Button className="sendButton" onClick={this.handleFinish}>
//                       Завершить
//                     </Button>
//                   </div>
//                 )}
//               </Modal.Content>
//             </Modal>
//             {/* <h3>У Вас нет магазинов</h3>
//             <Button color="green" onClick={this.onStartCreating}>
//               Добавить
//             </Button> */}
//             {creating && (
//               <Grid style={{ marginTop: "5px" }}>
//                 <Grid.Row>
//                   <Grid.Column computer={8} tablet={16}>
//                     <StoreCard
//                       createStore={createStore}
//                       cancelCreating={this.cancelCreating}
//                     />
//                   </Grid.Column>
//                 </Grid.Row>
//               </Grid>
//             )}
//           </>
//         ) : (
//           <Container className="select-store-page" text>
//             <Button color="green" onClick={this.onStartCreating}>
//               {"Добавить"}
//             </Button>
//             {creating && (
//               <Grid style={{ marginTop: "5px" }}>
//                 <Grid.Row>
//                   <Grid.Column computer={8} tablet={16}>
//                     <StoreCard
//                       createStore={createStore}
//                       cancelCreating={this.cancelCreating}
//                     />
//                   </Grid.Column>
//                 </Grid.Row>
//               </Grid>
//             )}
//             <h2>{"Выбрать магазин"}</h2>
//             <StoreHolder
//               stores={stores}
//               currentStore={currentStore}
//               deleteStore={deleteStore}
//               editStore={editStore}
//               selectStore={selectStore}
//             />
//             {/* {data} */}
//           </Container>
//         )}
//       </>
//     )
//   }
// }

// export default SelectStorePage
